import React from "react";

/**
 * Reusable section-block renderer used across the Student Book chapters.
 * Tone determines the eyebrow text + colour accent.
 */
export default function ChapterSection({ icon: Icon, number, title, tone, children }) {
  const eyebrow = {
    objective: "What pupils will learn",
    story: "Read aloud · 8 minutes",
    concept: "Concept explanation",
    context: "In Britain today",
    activity: "Class activity",
    reflection: "Reflection · take it home",
    teacher: "Teacher edition only",
  }[tone] || "";
  return (
    <div className="cb-section">
      <div className="cb-head">
        <div className="cb-num">{number}</div>
        <div className="cb-icon"><Icon size={18} /></div>
        <div className="cb-title-block">
          <span className="cb-eyebrow">{eyebrow}</span>
          <h3 className="cb-title">{title}</h3>
        </div>
      </div>
      <div className="cb-content">{children}</div>
    </div>
  );
}

export function CalloutBox({ label, children }) {
  return (
    <div className="cb-callout">
      <strong className="cb-callout-label">{label}</strong>
      <div>{children}</div>
    </div>
  );
}

export const CHAPTER_STYLES = `
  .cb-section { }
  .cb-head {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(0,27,58,0.1);
  }
  .cb-num {
    flex-shrink: 0;
    width: 48px; height: 48px;
    border-radius: 50%;
    background: #001B3A;
    color: #FDFBF7;
    font-family: 'Cormorant Garamond', serif;
    font-size: 22px;
    display: flex; align-items: center; justify-content: center;
  }
  .cb-icon {
    flex-shrink: 0;
    width: 36px; height: 36px;
    border-radius: 8px;
    background: rgba(207,160,82,0.15);
    color: #8B6E2A;
    display: flex; align-items: center; justify-content: center;
    margin-top: 6px;
  }
  .cb-title-block { flex: 1; }
  .cb-eyebrow {
    font-size: 10px; letter-spacing: 0.22em;
    text-transform: uppercase; color: #E07A5F; font-weight: 600;
  }
  .cb-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: 30px; line-height: 1.1; color: #001B3A; margin: 4px 0 0;
  }
  .cb-content { font-size: 15px; line-height: 1.65; color: #1f2937; }
  .cb-content p { margin: 0 0 14px; }
  .cb-content .lead { font-size: 16px; color: #001B3A; font-weight: 500; }
  .cb-content ul, .cb-content ol { padding-left: 22px; margin: 12px 0; }
  .cb-content li { margin-bottom: 6px; }
  .cb-content h4 {
    font-family: 'Cormorant Garamond', serif;
    font-size: 22px; color: #001B3A; margin: 22px 0 10px;
    padding-top: 14px; border-top: 1px dashed rgba(0,27,58,0.15);
  }
  .cb-callout {
    margin: 16px 0;
    padding: 16px 18px;
    background: rgba(224,122,95,0.08);
    border-left: 4px solid #E07A5F;
    border-radius: 4px;
    font-size: 14px; color: #1f2937;
  }
  .cb-callout-label {
    display: block;
    font-size: 10px; letter-spacing: 0.22em;
    text-transform: uppercase; color: #C44A2D;
    margin-bottom: 6px;
  }
  .cb-vocab {
    display: grid;
    grid-template-columns: 130px 1fr;
    gap: 6px 14px;
  }
  .cb-vocab dt {
    font-family: 'Cormorant Garamond', serif;
    font-weight: 600; color: #001B3A;
  }
  .cb-vocab dd { margin: 0; color: #4A5568; }
`;
